<template>
  <div class="chart-wrapper">
    <h3 class="chart-title">{{ $t(title) }}</h3>
    <vue-c3 class="chart-box" :handler="handler" />
  </div>
</template>

<script>
import Vue from 'vue';
import VueC3 from 'vue-c3';
import 'c3/c3.css';

export default {
  name: 'TrendChart',
  components: { VueC3 },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    title: {
      type: String,
      default: 'health.nutritionalPlan.glucoseCurve'
    },
    yLabel: {
      type: String,
      default: 'mg/dL'
    },
    color: {
      type: String,
      default: '#e06666'
    },
    yMax: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      handler: new Vue()
    };
  },
  watch: {
    data:  { handler() { this.draw(); }, deep: true },
    color: { handler() { this.draw(); } },
    yMax:  { handler() { this.draw(); } }
  },
  mounted() {
    this.$nextTick(() => {
      this.draw();
    });
    window.addEventListener('resize', this.draw);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.draw);
  },
  methods: {
    draw() {
      if (!this.data || !this.data.length) return;

      const xValues   = this.data.map(d => d.minutes);
      const upperVals = this.data.map(d => d.upperBound);
      const lowerVals = this.data.map(d => d.lowerBound);

      const options = {
        data: {
          x: 'x',
          columns: [
            ['x',     ...xValues],
            ['upper', ...upperVals],
            ['lower', ...lowerVals]
          ],
          types: {
            upper: 'area-spline',
            lower: 'area-spline'
          },
          colors: {
            upper: this.color,
            lower: '#ffffff'
          },
          order: null
        },
        legend: { show: false },
        axis: {
          x: {
            label: { text: this.$t('health.nutritionalPlan.timeMinutes'), position: 'outer-center' },
            tick: {
              values: [0, 30, 60, 90, 120],
              format: d => `${d}`
            },
            min: 0,
            max: 120,
            padding: { left: 2, right: 2 }
          },
          y: {
            min: 0,
            max: this.yMax,
            padding: { top: 0, bottom: 0 },
            label: { text: this.yLabel, position: 'outer-middle' }
          }
        },
        point: { show: true },
        spline: { interpolation: { type: 'monotone' } },
        tooltip: {
          grouped: true,
          format: {
            title: d => `${d} min`,
            name: id => id === 'upper' ? this.$t('health.nutritionalPlan.upperLimit') : this.$t('health.nutritionalPlan.lowerLimit'),
            value: (v) => `${v} ${this.yLabel}`
          }
        }
      };

      this.handler.$emit('init', options);
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  position: relative;
  flex: 1 1 100%;
  margin: 12px;
  padding: 20px;
  border-radius: 18px;
  background: #fff;
  box-shadow:
    0 0 0 1px rgba(224, 102, 102, 0.15),
    0 10px 20px rgba(0, 0, 0, 0.04);
}

.chart-title {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: center;
  color: #1e1e1e;
  font-family: 'Outfit', 'Segoe UI', sans-serif;
}

.chart-box {
  width: 100% !important;
  height: 280px !important;
  min-height: 250px;
}
</style>

<style>

.c3-area-base {
  fill: rgba(0, 0, 0, 0) !important;
  opacity: 0 !important;
}
.c3-line-base {
  display: none !important;
}
.c3-circles-base circle {
  display: none !important;
}

.c3-area-band {
  opacity: 0.2 !important;
}
.c3-line-band {
  display: none !important;
}
.c3-circles-band circle {
  display: none !important;
}


.c3-circle {
  fill: #fff !important;
  stroke-width: 2px !important;
}

.c3-area-upper {
  opacity: 0.3 !important;
}
.c3-line-upper {
  stroke-width: 0 !important;
  display: none !important;
}

.c3-area-lower {
  fill: #ffffff !important;
  opacity: 1 !important;
}
.c3-line-lower {
  stroke-width: 0 !important;
  display: none !important;
}

.c3-circles-upper circle,
.c3-circles-lower circle {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/GlucoseCurveChart.vue